import React, { useEffect, useState } from "react";
import {
  Container,
  Paper,
  Typography,
  useTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Button,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import useResponsive from "hooks/useResponsive";
import { getDriverDetailDatawithTime } from "api/busDrivers";
import { toast } from "react-toastify";
import customFetch from "../../hooks/fetchWrapper";

const CONFIG = {
  year: "2025-2026",
};

const fetchDriverDetailData = async (driverId = null, routeId = null) => {
  try {
    // Pass the selected filter IDs to the API function
    const response = await getDriverDetailDatawithTime(driverId, routeId);
    console.log("🚀 ~ fetchDriverDetailData ~ response:", response);

    if (
      response &&
      response.length > 0 &&
      response[0]["JSON_F52E2B61-18A1-11d1-B105-00805F49916B"]
    ) {
      // Parse the JSON string from the response
      const jsonString = response[0]["JSON_F52E2B61-18A1-11d1-B105-00805F49916B"];
      const parsedData = JSON.parse(jsonString); // Convert the string to an object
      console.log("🚀 ~ fetchDriverDetailData ~ parsedData:", parsedData);

      // Transform the parsed data into a structured format for the table
      const formattedData = parsedData.flatMap((driver, driverIndex) =>
        driver.pickups.map((pickup, index) => {
          console.log("🚀 ~ driver.pickups.map ~ pickup:", driver);
          return {
            id: `${driverIndex}-${index}`, // Unique ID using indices
            pickupOrder: index + 1, // Sequential order of pickups
            pickupCode: pickup.PickupCodes || "N/A",
            busStop: pickup.BustopNames || "N/A", // Pickup bus stop name
            areaCode: driver.AreaCode || "N/A", // Area Code from the driver
            pickupTime: pickup.PickupTimes || "N/A", // Pickup time
            dropOffTime: pickup.DropOffTimes || "N/A", // Drop off time
            driverName: driver.DriverName || "N/A", // Driver's name
            busNumber: driver.BusNumber || "N/A", // Bus number
            contactNumber: driver.ContactNumber || "N/A", // Contact number
            mapUrl: driver.map || "N/A", // Map URL
            routeNo: driver.routeno || "N/A", // Route number
            routeName: driver.routename || "N/A", // Route name
          };
        })
      );

      console.log("Formatted Data:", formattedData);
      return formattedData; // Return formatted data instead of setting state directly
    }

    return []; // Return empty array if no data
  } catch (error) {
    console.error("Error fetching driver details:", error);
    return []; // Return empty array on error
  }
};

function BusroutesTableDPSDubai({ white = true }) {
  const theme = useTheme();
  const [tableData, setTableData] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState("");
  console.log("🚀 ~ BusroutesTableDPSDubai ~ selectedDriver:", selectedDriver);
  const [selectedRoute, setSelectedRoute] = useState("");
  const [loading, setLoading] = useState(false);

  console.log("🚀 ~ BusroutesTableDPSDubai ~ routes:", routes);
  console.log("🚀 ~ BusroutesTableDPSDubai ~ drivers:", drivers);
  console.log("🚀 ~ BusroutesTableDPSDubai ~ tableData:", tableData);

  const mdDown = useResponsive("down", "md");

  const fetchRoutes = async () => {
    try {
      const data = await customFetch("routes");
      if (data.status && Array.isArray(data.data)) {
        setRoutes(data.data);
      } else {
        console.error("Unexpected response format:", data);
        setRoutes([]);
      }
    } catch (error) {
      console.error("Error fetching routes:", error);
      setRoutes([]);
    }
  };

  const fetchDrivers = async () => {
    try {
      const data = await customFetch("getDriverDetails/0");
      console.log("🚀 ~ fetchDrivers ~ data:", data);

      if (data && Array.isArray(data)) {
        setDrivers(data);
      } else {
        console.error("Unexpected response format:", data);
        setDrivers([]);
      }
    } catch (error) {
      console.error("Error fetching drivers:", error);
      setDrivers([]);
    }
  };

  const loadData = async (driverId = null, routeId = null) => {
    setLoading(true);
    try {
      const data = await fetchDriverDetailData(driverId, routeId);
      // Always set the tableData with the response (even if it's an empty array)
      setTableData(data);
      if (data.length === 0) {
        toast.info("No data found for the selected filter");
      }
      // else {
      //   toast.success("Data loaded successfully!");
      // }
    } catch (error) {
      console.error("Error loading data:", error);
      setTableData([]); // Clear table data on error
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoutes();
    fetchDrivers();

    // Initial data fetch without filters
    loadData();
  }, []);

  const handleDriverChange = (event) => {
    const driverId = event.target.value;
    setSelectedDriver(driverId);
    setSelectedRoute(""); // Reset route filter

    // Load data with driver filter
    loadData(driverId, null);
  };

  const handleRouteChange = (event) => {
    const routeId = event.target.value;
    setSelectedRoute(routeId);
    setSelectedDriver(""); // Reset driver filter

    // Load data with route filter
    loadData(null, routeId);
  };

  const handleResetFilters = () => {
    setSelectedDriver("");
    setSelectedRoute("");

    // Load data without filters
    loadData();
  };

  // Driver Details Component - Add this before the DataGrid in your render section
  const DriverDetailsCard = () => {
    // Find the currently selected driver from state
    const selectedDriverData = selectedDriver
      ? drivers.find((driver) => driver.DriverID.toString() === selectedDriver.toString())
      : null;
    console.log("🚀 ~ DriverDetailsCard ~ selectedDriverData:", selectedDriverData);

    console.log("🚀 ~ DriverDetailsCard ~ tableData:", tableData);
    // Find the first driver from the tableData if we're filtering by route
    const firstDriverInRoute =
      tableData.length > 0
        ? {
            driverName: tableData[0].driverName,
            contactNumber: tableData[0].contactNumber,
            busNumber: tableData[0].busNumber,
            routeName: selectedRoute
              ? routes.find((r) => r.rid.toString() === selectedRoute.toString())?.routename
              : null,
            mapUrl: tableData[0].mapUrl,
            routeNo: tableData[0].routeNo,
          }
        : null;

    // Use driver data based on which filter is active
    let driverData = null;

    if (selectedDriver && selectedDriverData) {
      driverData = selectedDriverData;
    } else if (selectedRoute && firstDriverInRoute && firstDriverInRoute.driverName !== "N/A") {
      driverData = firstDriverInRoute;
    }

    if (!driverData) return null;
    console.log("🚀 ~ DriverDetailsCard ~ driverData:", driverData);

    return (
      <Paper sx={{ mb: 3, overflow: "hidden", border: "none" }}>
        <Box sx={{ display: "flex", flexDirection: mdDown ? "column" : "row" }}>
          <Box
            sx={{
              width: mdDown ? "100%" : "140px",
              height: mdDown ? "165px" : "165px",
              bgcolor: "#6faca6",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 1,
            }}
          >
            <img
              src="https://www.mauicardiovascularsymposium.com/wp-content/uploads/2019/08/dummy-profile-pic-300x300.png"
              alt="Driver"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                maxWidth: "120px",
                maxHeight: "120px",
              }}
            />
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr style={{ backgroundColor: "#6faca6" }}>
                  <td
                    style={{
                      padding: "3px 12px",
                      fontWeight: "bold",
                      border: "1px solid #1c2c2a",
                      width: "30%",
                    }}
                  >
                    ROUTE NUMBER
                  </td>
                  <td style={{ padding: "3px 12px", border: "1px solid #1c2c2a" }}>
                    {driverData.routeNo || tableData[0].routeNo || "-"}
                  </td>
                </tr>
                <tr style={{ backgroundColor: "#6faca6" }}>
                  <td
                    style={{ padding: "3px 12px", fontWeight: "bold", border: "1px solid #1c2c2a" }}
                  >
                    ROUTE NAME
                  </td>
                  <td style={{ padding: "3px 12px", border: "1px solid #1c2c2a" }}>
                    {(selectedRoute &&
                      routes.find((r) => r.rid.toString() === selectedRoute.toString())
                        ?.routename) ||
                      tableData[0].routeName ||
                      "-"}
                  </td>
                </tr>
                <tr style={{ backgroundColor: "#6faca6" }}>
                  <td
                    style={{ padding: "3px 12px", fontWeight: "bold", border: "1px solid #1c2c2a" }}
                  >
                    DRIVER NAME
                  </td>
                  <td style={{ padding: "3px 12px", border: "1px solid #1c2c2a" }}>
                    {driverData.driverName || driverData.DriverName || "-"}
                  </td>
                </tr>
                <tr style={{ backgroundColor: "#6faca6" }}>
                  <td
                    style={{ padding: "3px 12px", fontWeight: "bold", border: "1px solid #1c2c2a" }}
                  >
                    CONTACT NUMBER
                  </td>
                  <td style={{ padding: "3px 12px", border: "1px solid #1c2c2a" }}>
                    {driverData.contactNumber || driverData.ContactNumber || "-"}
                  </td>
                </tr>
                <tr style={{ backgroundColor: "#6faca6" }}>
                  <td
                    style={{ padding: "3px 12px", fontWeight: "bold", border: "1px solid #1c2c2a" }}
                  >
                    ROUTE MAP
                  </td>
                  <td style={{ padding: "3px 12px", border: "1px solid #1c2c2a" }}>
                    {driverData.mapUrl || (tableData.length > 0 && tableData[0].mapUrl) ? (
                      <a
                        href={driverData.mapUrl || tableData[0].mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#0D47A1",
                          textDecoration: "underline",
                          fontWeight: "bold",
                        }}
                      >
                        View Route Map
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </Box>
        </Box>
      </Paper>
    );
  };

  const columns = [
    { field: "pickupOrder", headerName: "ORDER", width: 90 },
    { field: "pickupCode", headerName: "PICK UP CODE", width: 120 },
    { field: "busStop", headerName: "BUS STOP", width: 200 },
    { field: "areaCode", headerName: "AREA CODE", width: 120 },
    { field: "pickupTime", headerName: "PICK UP TIME", width: 150 },
    { field: "dropOffTime", headerName: "DROP OFF TIME", width: 150 },
    { field: "busNumber", headerName: "BUS NUMBER", width: 120 },
    { field: "driverName", headerName: "DRIVER NAME", width: 180 },
    { field: "contactNumber", headerName: "DRIVER MOBILE", width: 180 },
  ];

  return (
    <div style={{ background: white && theme.palette.background.paper }}>
      <Container maxWidth="xl" sx={{ py: 7 }}>
        <Typography
          variant={mdDown ? "h3" : "h1"}
          textAlign="center"
          fontWeight="700"
          fontFamily='"Merriweather", serif'
        >
          BUS ROUTES FOR THE ACADEMIC YEAR {CONFIG.year}
        </Typography>

        {/* Filter section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: mdDown ? "column" : "row",
            gap: 2,
            mt: 5,
            mb: 2,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: mdDown ? "column" : "row",
              gap: 2,
              width: mdDown ? "100%" : "70%",
              justifyContent: "flex-start",
            }}
          >
            <FormControl fullWidth sx={{ minWidth: 200 }}>
              <InputLabel id="driver-select-label">Filter by Driver</InputLabel>
              <Select
                labelId="driver-select-label"
                id="driver-select"
                value={selectedDriver}
                label="Filter by Driver"
                onChange={handleDriverChange}
                disabled={loading}
              >
                <MenuItem value="">
                  <em>All Drivers</em>
                </MenuItem>
                {drivers.map((driver) => (
                  <MenuItem key={driver.DriverID} value={driver.DriverID}>
                    {driver.DriverName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ minWidth: 200 }}>
              <InputLabel id="route-select-label">Filter by Route</InputLabel>
              <Select
                labelId="route-select-label"
                id="route-select"
                value={selectedRoute}
                label="Filter by Route"
                onChange={handleRouteChange}
                disabled={loading}
              >
                <MenuItem value="">
                  <em>All Routes</em>
                </MenuItem>
                {routes.map((route) => (
                  <MenuItem key={route.rid} value={route.rid}>
                    {route.routename}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Button
            variant="outlined"
            onClick={handleResetFilters}
            disabled={loading || (!selectedDriver && !selectedRoute)}
            sx={{ minWidth: 120 }}
          >
            Reset Filters
          </Button>
        </Box>

        {/* Render the driver details card only when a filter is applied */}
        {(selectedDriver || selectedRoute) && tableData.length > 0 && <DriverDetailsCard />}

        <Paper sx={{ mt: 2, height: 500 }}>
          <DataGrid
            rows={tableData}
            columns={columns}
            getRowId={(row) => row.id || `${Math.random()}`} // Ensure unique ID even with problematic data
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[10, 20, 50]}
            disableColumnMenu
            loading={loading}
            noRowsOverlayProps={{
              sx: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              },
            }}
            noRowsOverlay={() => (
              <Box sx={{ textAlign: "center", p: 2 }}>
                <Typography variant="body1">
                  {loading ? "Loading data..." : "No data available for the selected filter"}
                </Typography>
              </Box>
            )}
          />
        </Paper>
      </Container>
    </div>
  );
}

export default BusroutesTableDPSDubai;
